import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SuccessMessage } from '../models/successMessage';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class ChecklistService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }
  getTypes(): Observable<any> {
    // return this.http.get<any>(this.baseUrl + 'qualitytypes');
    return this.http.get<any>(this.O3CoreApiUrl + 'QualityTypes/GetAllQualityTypes');
     
  }
  getItemTypes(): Observable<any> {
    // return this.http.get<any>(this.baseUrl + 'itemtypes');
    return this.http.get<any>(this.O3CoreApiUrl + 'QualityTypes/GetItemTypes');
    
  }
  getCheckList(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'allqualitychecklists', data);
     return this.http.post<any[]>(this.O3CoreApiUrl + 'QualityChecklist/GetAllQualityCheckLists', data);
  }

  getCheckListById(checkList: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'qualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/GetQualityCheckListById', checkList);
  }

  addCheckListdata(checkList: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'addqualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/AddQualityCheckList', checkList);
    
  }
  //NOT IN USE
  // updateCheckListdataById(checkList: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'qualitychecklist', checkList);
  // }
  updateCheckListdata(checkList: any): Observable<any[]> {
    //return this.http.put<any[]>(this.baseUrl + 'qualitychecklist', checkList);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Qualitycheckexecution/UpdateQualityCheckList', checkList);
  }
  deletechecklist(data: any): Observable<SuccessMessage> {
    //return this.http.post<SuccessMessage>(this.baseUrl + 'deletequalitychecklist', data);
    return this.http.post<SuccessMessage>(this.O3CoreApiUrl + 'QualityChecklist/DeleteQualityList', data);

  }

  saveCheckListType(data: any){
    //return this.http.post(this.baseUrl + 'createQualityType', data);
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/CreateQualityType', data);
  }

  editCheckListType(data: any){
    //return this.http.post(this.baseUrl + 'updateQualityTypes', data);
    return this.http.post(this.O3CoreApiUrl + 'QualityTypes/UpdateQualityTypes', data);
  }

  deleteCheckListType(data: any){
   // return this.http.post(this.baseUrl + 'deleteQualityTypes', data);
   return this.http.post(this.O3CoreApiUrl + 'QualityTypes/DeleteQualityTypes', data);
  }
}
